import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TransactionItemClassification  {
    _originalTypeClassName = "zERP.BO.TransactionItemClassification";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TransactionItemClassification.translate = translateService;
}
this.ExpensesClassificationTypes = [];
this.IncomeClassificationTypes = [];
this.Id = null;
this.TransactionType = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
TransactionType:any;
ExpensesClassificationCategory:any;
IncomeClassificationCategory:any;
ExpensesClassificationTypes:any;
IncomeClassificationTypes:any;
InvoiceType:any;
static setExpensesClassificationCategory = ($this, value) => {
var oldValue = $this.ExpensesClassificationCategory;
$this.ExpensesClassificationCategory = value;
if (value != null) {
}
}
static setIncomeClassificationCategory = ($this, value) => {
var oldValue = $this.IncomeClassificationCategory;
$this.IncomeClassificationCategory = value;
if (value != null) {
}
}
static setExpensesClassificationTypes = ($this, items) => {
                if (items == null) items = [];
                if ($this.ExpensesClassificationTypes == null) $this.ExpensesClassificationTypes = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ExpensesClassificationTypes.length > 0) {
                    Domain.TransactionItemClassification.removeExpensesClassificationTypes($this, $this.ExpensesClassificationTypes[0]);
                }

                Domain.TransactionItemClassification.addManyExpensesClassificationTypes($this, copyItems);
            }
static addManyExpensesClassificationTypes = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.TransactionItemClassification.addExpensesClassificationTypes($this, items[i]);
                }
            }
static addExpensesClassificationTypes = ($this, item) => {
                if ($this.ExpensesClassificationTypes == null) $this.ExpensesClassificationTypes = [];
                if (item == null || $this.ExpensesClassificationTypes.indexOf(item) > -1) return;
                $this.ExpensesClassificationTypes.push(item);
}
static addRangeExpensesClassificationTypes = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.TransactionItemClassification.addExpensesClassificationTypes($this, item));
            }
static removeExpensesClassificationTypes = ($this, item) => {
                if ($this == null || $this.ExpensesClassificationTypes == null || $this.ExpensesClassificationTypes.indexOf(item) === -1) return;
                var _index = $this.ExpensesClassificationTypes.indexOf(item);
                $this.ExpensesClassificationTypes.splice(_index, 1);
}
static clearExpensesClassificationTypes = ($this) => { $this.ExpensesClassificationTypes = null; }
static setIncomeClassificationTypes = ($this, items) => {
                if (items == null) items = [];
                if ($this.IncomeClassificationTypes == null) $this.IncomeClassificationTypes = [];

                const copyItems = Common.cloneObject(items);

                while ($this.IncomeClassificationTypes.length > 0) {
                    Domain.TransactionItemClassification.removeIncomeClassificationTypes($this, $this.IncomeClassificationTypes[0]);
                }

                Domain.TransactionItemClassification.addManyIncomeClassificationTypes($this, copyItems);
            }
static addManyIncomeClassificationTypes = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.TransactionItemClassification.addIncomeClassificationTypes($this, items[i]);
                }
            }
static addIncomeClassificationTypes = ($this, item) => {
                if ($this.IncomeClassificationTypes == null) $this.IncomeClassificationTypes = [];
                if (item == null || $this.IncomeClassificationTypes.indexOf(item) > -1) return;
                $this.IncomeClassificationTypes.push(item);
}
static addRangeIncomeClassificationTypes = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.TransactionItemClassification.addIncomeClassificationTypes($this, item));
            }
static removeIncomeClassificationTypes = ($this, item) => {
                if ($this == null || $this.IncomeClassificationTypes == null || $this.IncomeClassificationTypes.indexOf(item) === -1) return;
                var _index = $this.IncomeClassificationTypes.indexOf(item);
                $this.IncomeClassificationTypes.splice(_index, 1);
}
static clearIncomeClassificationTypes = ($this) => { $this.IncomeClassificationTypes = null; }
static setInvoiceType = ($this, value) => {
var oldValue = $this.InvoiceType;
$this.InvoiceType = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}